function only(array, key) {
  return array.reduce((acc, item) => {
    acc[item.title.toUpperCase().replace(/\s+/g, '_')] = item[key];
    return acc;
  }, {});
}

const settings = {
  title: 'Settings',
  url: '/portal/settings',
  faIcon: 'user-gear',
  iconActive: 'user-gear',
  requiresAppComplete: true,
};

export const NAV_LINKS = {
  dashboard: {
    title: 'Dashboard',
    url: '/portal',
    faIcon: 'house',
    iconActive: '/images/portal-dash-active.png',
    requiresAppComplete: true,
  },
  options: {
    title: 'Financing Options',
    url: '/portal/options',
    faIcon: 'file-invoice-dollar',
    iconActive: '/images/portal-offers-active.png',
    requiresAppComplete: true,
  },
  documents: {
    title: 'Document Center',
    url: '/portal/documents',
    faIcon: 'folder',
    iconActive: '/images/portal-resources-active.png',
    requiresAppComplete: true,
  },
  explore: {
    title: 'Explore',
    url: '/portal/explore-other-products',
    faIcon: 'sack-dollar',
    iconActive: '/images/portal-resources-active.png',
    requiresAppComplete: true,
  },
}

export const PORTAL_NAV_LINKS = [
  ...Object.values(NAV_LINKS),
  settings,
]

export const EMBEDDED_NAV_LINKS = [
  {
    ...NAV_LINKS.dashboard,
    url: '/embedded/portal/dashboard',
  },
  {
    ...NAV_LINKS.options,
    url: '/embedded/portal',
  },
  {
    ...NAV_LINKS.documents,
    title: 'Documents',
    url: '/embedded/portal/documents',
  },
]

export const INTELLIGENT_LENDING_NAV_LINKS = [
  {
    ...NAV_LINKS.dashboard,
    faIcon: 'border-all',
  },
  {
    ...NAV_LINKS.options,
  },
  {
    ...NAV_LINKS.documents,
  },
  settings,
]

export const BRANDED_NAV_LINKS = [
  {
    ...NAV_LINKS.dashboard,
    faIcon: 'border-all',
  },
  NAV_LINKS.options,
  NAV_LINKS.documents,
  settings,
]

export const PORTAL_APP_STATE = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  LENDER_DOCS: 'LENDER_DOCS',
  BANK_DOCS: 'BANK_DOCS',
}

export const PROGRESS_STEPS = {
  steps: [
    {
      label: 'Application',
      active: true,
    },
    {
      label: 'Under review',
      active: true,
    },
    {
      label: 'Options ready',
      active: true,
    },
    {
      label: 'Closing',
      active: false,
    },
    {
      label: 'Funded',
      active: false,
    }
  ]
}

export const HOURS = 1000 * 60 * 60 // MS -> Seconds -> Minutes -> Hours

export const DAYS = HOURS * 24

export const PPP_LOAN_TYPES = ['sbaPpp', 'sbaPPPSecond']

export const BORROWER_PROGRESSION_STAGES = {
  VIEWING_FINANCING_OPTIONS: 1,
  VIEWING_ACCEPTED_FINANCING_OPTION: 2,
  STORY_ARC_BREAKING_THE_NEWS: 3,
}

export const BORROWER_EXPERIMENTS = {
  EXPECTATIONS_STORY_ARC: 82,
  NEW_OPTION_TOP_CARD: 140,
  MASTERCARD_BANK_TRUST: 141,
  ALL_OPTIONS_V2: 155,
}

export const PORTAL_NAV_TITLES = only(PORTAL_NAV_LINKS, 'title');

export const PORTAL_NAV_URLS = only(PORTAL_NAV_LINKS, 'url');

export const EMBEDDED_PORTAL_NAV_TITLES = only(EMBEDDED_NAV_LINKS, 'title');

export const EMBEDDED_PORTAL_NAV_URLS = only(EMBEDDED_NAV_LINKS, 'url');

export const INTELLIGENT_LENDING_PORTAL_NAV_TITLES = only(INTELLIGENT_LENDING_NAV_LINKS, 'title');

export const INTELLIGENT_LENDING_PORTAL_NAV_URLS = only(INTELLIGENT_LENDING_NAV_LINKS, 'url');

export const BRANDED_PORTAL_NAV_TITLES = only(BRANDED_NAV_LINKS, 'title');

export const BRANDED_PORTAL_NAV_URLS = only(BRANDED_NAV_LINKS, 'url');

export const QUANTUM_LOC_PRODUCT_ID = 308; // TODO: remove this hardcoded value once we have a better way to identify quantum LOC product

export const OPTION_INSIGHTS = {
  RECOMMENDED: {
    tag: 'Recommended',
    insight: 'Matched to your business, profile, funding history, and loan fit.',
  },
  SPEED: {
    tag: 'Fast Funding',
    insight: 'Faster to fund than all other options shown.',
  },
  COST: {
    tag: 'Lowest cost',
    insight: 'Lowest total repayment across all options shown.',
  },
  AMOUNT: {
    tag: 'Closest to your ask',
    insight: 'Offer amount is within 85% of what you requested.',
  }
}
